
































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { AxiosResponse, AxiosError } from 'axios'
import Cookies from "js-cookie";

@Component({
  components: {}
})
export default class ServerMod extends Vue {
  private loading = true;
  private token = Cookies.get("sqfsafe_auth");

  private profiles = [];

   private newObf = {
    id: null,
    text: "Select a profile",
    name: "",
    ignored_files: "",
    files_not_encrypted: "",
    block_editor: true,
    encryption_key: ""
  };

  private obfuscation = this.newObf;

  private async created() {
    let response = await axios.post('https://sqfsafe.com/api/obfuscation/list-profiles');
    let data = response.data;

    if (data.success) {
      this.profiles = data.profiles;
      
    } else {
      alert("Error loading existing profiles, try refreshing the page");
    }

    this.loading = false;
  }


  private download() {

    if (!this.token) {
      this.$router.push('/login');
      return;
    }

    let encryptionKey = this.obfuscation.encryption_key;

    if (!encryptionKey) {
      alert("You must select a valid obfuscation profile before you can download the server mod");
      return;
    }

    this.loading = true;

    let formData = new FormData();
    formData.append("encryption_key", encryptionKey);
    formData.append("token", this.token);

    axios.post("https://sqfsafe-api.arma.dev/servermod", formData, {
        headers: {
         "Content-Type": "multipart/form-data"
        },
        responseType: 'blob'
    }).then((response) => {

      let fileURL = window.URL.createObjectURL(new Blob([response.data]));
      let fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "sqfsafe.zip");

      document.body.appendChild(fileLink);

      fileLink.click();

      this.loading = false;
    }).catch((error) => {

      if (error.response.status == 403) {
        alert("Looks like you're no longer authenticated, has your session timed out? Try refreshing the page and checking your subscription status.");
        return;
      } else {
        alert("Unknown server error occured with code: " + error.response.status);
      }

      this.loading = false;
    })
  }
}
